import { inject, observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import CheckoutModule from '../../common/CheckoutModule';
import CheckoutSummary from '../CheckoutSummary';
import CheckoutSummaryLogo from '../CheckoutSummaryLogo';
import UIStore from '../../../../store/UIStore';

const CheckoutSummaryModule = ({ checkoutStore, uiStore }) => {
  const { order } = checkoutStore;
  const { summaryAlerts } = order;

  return (
    <CheckoutModule
      className="CheckoutSummaryModule"
      generalAlerts={summaryAlerts.general}
      errorAlerts={summaryAlerts.errors}
      alertsBelow
      headerLogo={uiStore.isDesktop ? <CheckoutSummaryLogo /> : null}
      title={
        <FormattedMessage
          id="checkout.summaryModule.title"
          defaultMessage="Summary"
        />
      }
    >
      <CheckoutSummary />
    </CheckoutModule>
  );
};

CheckoutSummaryModule.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
};

export default inject(
  'checkoutStore',
  'uiStore'
)(observer(CheckoutSummaryModule));
